export default "__VITE_ASSET__BdYqRuBR__"